import React, { useEffect, useState } from "react";
import FeatherIcon from "feather-icons-react";
import Button from "./button";

const INPUT_CLASS =
  "block w-full appearance-none !rounded !border-2 !border-solid !border-line !bg-white !px-2 !py-1.5 text-sm text-ink placeholder:text-ink-subtlest focus:!border-brand focus:outline-none";

const AdminUpdateUserLimitsModal = ({ isOpen, onClose, onSubmit, rateLimitHour, rateLimitDay }) => {
  const [hourLimit, setHourLimit] = useState(0);
  const [dayLimit, setDayLimit] = useState(0);
  const [error, setError] = useState("");

  useEffect(() => {
    const modal = document.getElementById("update-limits-modal");
    if (isOpen) {
      modal.showModal();
    } else if (modal.open) {
      modal.close();
    }
  }, [isOpen]);

  const handleClose = () => {
    onClose();
  };

  const handleESC = (event) => {
    event.preventDefault();
    handleClose();
  }

  useEffect(() => {
    setHourLimit(rateLimitHour);
    setDayLimit(rateLimitDay);
  }, [rateLimitHour, rateLimitDay]);

  const submitForm = () => {
    if (hourLimit < 0 || dayLimit < 0) {
      setError("Both limits must be greater than zero");
      return;
    }
    setError("");
    onSubmit({ rateLimitHour: hourLimit, rateLimitDay: dayLimit });
    handleClose();
  };

  return (
    <dialog id="update-limits-modal" className="modal backdrop:bg-[#091E428A]" onCancel={handleESC}>
      <div className="relative col-start-1 row-start-1 max-h-[calc(100vh-5em)] w-11/12 max-w-md overflow-y-auto rounded-md bg-white text-ink shadow-overlay">
        <div className="modal-content">
          <button
            type="button"
            aria-label="Sluiten"
            className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded text-ink-subtlest hover:bg-[#091E420F]"
            onClick={handleClose}
          >
            <FeatherIcon icon="x" size={16} />
          </button>
          <h1 className="modal-title px-6 pt-6 text-xl font-medium text-ink">
            Update User Rate Limits
          </h1>
          <form className="update-profile-form !mt-0 px-6 py-4">
            <div className="grid grid-cols-1 gap-4">
              <div>
                <label htmlFor="hourLimit" className="mb-1 block text-xs font-semibold text-ink-subtlest">Hourly Rate Limit</label>
                <input
                  id="hourLimit"
                  name="hourLimit"
                  type="number"
                  placeholder="Enter hourly rate limit"
                  className={INPUT_CLASS}
                  value={hourLimit}
                  onChange={(e) => setHourLimit(Number(e.target.value))}
                />
              </div>
              <div>
                <label htmlFor="dayLimit" className="mb-1 block text-xs font-semibold text-ink-subtlest">Daily Rate Limit</label>
                <input
                  id="dayLimit"
                  name="dayLimit"
                  type="number"
                  placeholder="Enter daily rate limit"
                  className={INPUT_CLASS}
                  value={dayLimit}
                  onChange={(e) => setDayLimit(Number(e.target.value))}
                />
              </div>
              <div className="invalid-feedback min-h-[16px] text-xs font-normal text-[#AE2A19]">
                {error}
              </div>
            </div>
            <div className="mt-4 flex justify-end gap-2">
              <Button btnClassNames="h-8 rounded bg-brand px-3 text-sm font-medium text-white hover:bg-brand-hover" text={'Update Limits'} type={'button'} onClick={submitForm} />
            </div>
          </form>
        </div>
      </div>
    </dialog>
  );
};

export default AdminUpdateUserLimitsModal;
